import React from 'react'
import { withPrefix } from 'gatsby'
// Custom Fork
import { LazyLoadImage } from 'react-lazy-load-image-component'
import '~2023/utils/react-lazy-load-image-component/effects/blur.css'

const ImageBackgroundCard = ({
  imageCard, // eslint-disable-line no-unused-vars
  imageCardDesktop,
  imageCardMobile, // eslint-disable-line no-unused-vars
  imageCardPlaceholder,
  imageCardTablet, // eslint-disable-line no-unused-vars
}) => {
  return (
    // @note[refactor] Allow acceptance of string fo height/width for percentage
    <LazyLoadImage
      delayTime={0}
      delayMethod="throttle"
      effect="blur"
      height="100%"
      placeholderSrc={withPrefix(imageCardPlaceholder)}
      sizes="(min-width: 960px) 294px, 50vw"
      src={withPrefix(imageCardMobile)}
      srcSet={`
        ${withPrefix(imageCardMobile)} 165w, ${withPrefix(
        imageCardTablet
      )} 262w, ${withPrefix(imageCardDesktop)} 570w
      `}
      style={{
        border: '3px solid black',
        left: '0',
        marginBottom: '0',
        objectFit: 'cover',
        position: 'absolute',
        top: '0',
        zIndex: '4',
      }}
      threshold={210}
      useIntersectionObserver={true}
      visibleByDefault={false}
      width="100%"
      wrapperClassName="cardInside card--inside card--item"
    />
  )
}

export default ImageBackgroundCard
